import type { ShotStatus } from "@dramapie/shared";

/**
 * 状态语气。
 * 视觉规范 §3/§4：`draft→待生成 / keyframe_ready→待复核 / approved→已确认 / failed→失败`。
 * tone 同时决定状态点、镜头带色块、缩略图角标的颜色。
 */
export type Tone = "approved" | "review" | "pending" | "error";

export const SHOT_STATUS_META: Record<ShotStatus, { label: string; tone: Tone }> = {
  draft: { label: "待生成", tone: "pending" },
  keyframe_ready: { label: "待复核", tone: "review" },
  approved: { label: "已确认", tone: "approved" },
  failed: { label: "失败", tone: "error" },
};

export const DIALOGUE_TYPE_LABEL = {
  speech: "说",
  thought: "想",
  vo: "画外",
} as const;

const ID_PREFIXES = /^(sht|chr|scn|ep|prj|out)_/;

/**
 * 契约里的 id 在前端只显示尾段：`sht_s1 → s1`、`sht_g001 → g001`。
 * 没有前缀的 id 原样显示（不猜、不补零）。
 */
export function shortId(id: string): string {
  return id.replace(ID_PREFIXES, "");
}
